<style>
  @import url("https://fonts.googleapis.com/css2?family=Satisfy&display=swap");
</style>
<a href="https://www.renovationunderwriting.com/"
  ><img class="brand-logo" src="/assets/img/ru-geo.svg" alt=""
/></a>
<router-outlet></router-outlet>
<footer>
  <span class="copywright"
    >Renovation Underwriting {{ date | date : "y" }}</span
  >
  <a href="https://vitaledigital.co.uk" class="poweredBy"
    >Powered by Vitale-Digital</a
  >
</footer>
